import { BankIconProps } from "./props"
import { StyledIcon } from "./styled"
import UIIcon from "../UIIcon"

const BankIcon = ({ size, logoUrl, onClick }: BankIconProps) => {
  const source = logoUrl || null

  return source ? (
    <StyledIcon onClick={onClick} src={source} size={size} alt="bankIcon" />
  ) : (
    <UIIcon onClick={onClick} iconName="sbpBox" size={Number(size)} />
  )
}

export default BankIcon
